import { Component } from 'react';

// eslint-disable-next-line import/no-cycle
import ContactFormNoCustomer from 'common/components/contactForm/ContactFormNoCustomer';
import ContactFormSuccess from 'common/components/contactForm/ContactFormSuccess';

import { getContinueShopping } from '../../helpers/miscHelper';

class NeedHelp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: null
    };
  }

  handleContactUs = (e) => {
    e.preventDefault();
    this.setState({
      modal: 'ContactForm'
    });
  };

  handleContactUsSuccess = () => {
    this.setState({
      modal: 'ContactFormSuccess'
    });
  };

  handleCloseModal = () => {
    this.setState({
      modal: null
    });
  };

  render() {
    const { hasContinueShopping, type, order, reservation, email, settings } =
      this.props;
    const { modal } = this.state;
    return (
      <>
        <div className="c7-order__buttons">
          <p className="c7-icon c7-icon--help">
            {' '}
            Need help? <a onClick={this.handleContactUs}>Contact Us</a>
          </p>
          {hasContinueShopping && (
            <a href={getContinueShopping(settings)} className="c7-button">
              Continue shopping
            </a>
          )}
        </div>
        {renderModal(
          modal,
          type,
          order,
          reservation,
          email,
          this.handleCloseModal,
          this.handleContactUsSuccess
        )}
      </>
    );
  }
}

const renderModal = (
  modal,
  type,
  order,
  reservation,
  email,
  handleCloseModal,
  handleContactUsSuccess
) => {
  switch (modal) {
    case 'ContactForm': {
      return (
        <ContactFormNoCustomer
          type={type}
          order={order}
          reservation={reservation}
          email={email}
          onCloseModal={handleCloseModal}
          onSuccess={handleContactUsSuccess}
        />
      );
    }
    case 'ContactFormSuccess': {
      return <ContactFormSuccess onCloseModal={handleCloseModal} />;
    }
    default: {
      return null;
    }
  }
};

export default NeedHelp;
